import { Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Navbar,
  Nav,
  NavDropdown,
  Modal,
  Button,
} from "react-bootstrap";
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaUser,
  FaCartArrowDown,
} from "react-icons/fa";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../contexts/CartContext";
import axios from "axios";
import { API_BASE_URL } from "../config";
import Login from "../pages/Login"; // adjust path
import Register from "../pages/Register"; // adjust path
import AstrologerRegister from "../pages/astrologer/Register";

export default function CustomNavbar() {
  const { items } = useCart();
  const cartCount = items.length;
  const [showDropdown, setShowDropdown] = useState({});
  const navigate = useNavigate();
  const [unseenCount, setUnseenCount] = useState(0);

  // ✅ Utility to always read sessionStorage fresh
  const getSessionData = (key) => {
    try {
      return JSON.parse(sessionStorage.getItem(key));
    } catch {
      return null;
    }
  };

  const authSession = getSessionData("authSession");
  // const authData = authSession ? JSON.parse(authSession) : null;
  const token = authSession?.jwt_token || null;
  const viewer_type = authSession?.role === "astrologer"
    ? "astrologer"
    : "user";
  const viewer_id = authSession?.user_id;
  // ✅ Convert string date → timestamp for safe comparison
  const isLoggedIn =
    authSession &&
    authSession.token_expires_at &&
    new Date(authSession.token_expires_at).getTime() > Date.now();

  let profileUrl = null;
  let name = "";

  if (authSession) {
    if (authSession.role === "user") {
      profileUrl = "/profile";
      name = authSession.first_name || "User";
    } else if (authSession.role === "astrologer") {
      profileUrl = "/astrologer/profile";
      name = authSession.first_name || "Astrologer";
    }
  }

  const handleLogout = () => {
    sessionStorage.removeItem("authSession"); // clear session only
    navigate("/login");
  };

  const handleMouseEnter = (menu) =>
    setShowDropdown((prev) => ({ ...prev, [menu]: true }));
  const handleMouseLeave = (menu) =>
    setShowDropdown((prev) => ({ ...prev, [menu]: false }));

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/chat/unseen-count`, {
        params: {
          viewer_id: viewer_id,
          viewer_type: viewer_type
        },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setUnseenCount(res.data.count))
      .catch(() => { });
  }, []);
  return (
    <>
      <div
        style={{
          background: "#1e2c49ff",
          fontSize: "14px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        }}
      >
        <Container className="py-2 px-3">
          <Row className="align-items-center text-center text-md-start">
            {/* Logo */}
            <Col
              xs={12}
              md={3}
              className="mb-2 mb-md-0 d-flex align-items-center justify-content-center justify-content-md-start"
            >
              <Navbar.Brand
                as={Link}
                to="/"
                className="text-white fw-bold fs-5"
                style={{ textShadow: "1px 1px 2px rgba(0,0,0,0.2)" }}
              >
                🔮 AstroPortal
              </Navbar.Brand>
            </Col>

            {/* Phone Number */}
            <Col
              xs={12}
              md={3}
              className="mb-2 mb-md-0 d-flex align-items-center justify-content-center"
            >
              <span className="fw-semibold text-white">📞 +91 9876543210</span>
            </Col>

            {/* Links */}
            <Col
              xs={12}
              md={3}
              className="mb-2 mb-md-0 d-flex align-items-center justify-content-center justify-content-md-start gap-3"
            >
              <Link
                to={isLoggedIn ? "#" : "/login"} // prevent navigation if logged in
                className="fw-bold text-white text-decoration-none px-2 py-1 rounded"
                style={{
                  transition: "0.3s",
                  background: "rgba(255,255,255,0.1)",
                }}
                onClick={(e) => {
                  if (isLoggedIn) {
                    e.preventDefault(); // stop <Link> from navigating
                    handleLogout(); // logout
                  }
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.background = "rgba(255,255,255,0.25)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.background = "rgba(255,255,255,0.1)")
                }
              >
                {isLoggedIn ? "Logout" : "Login"}
              </Link>

              <Link
                to="/astrologer/register"
                className="fw-bold text-white text-decoration-none px-2 py-1 rounded"
                style={{
                  transition: "0.3s",
                  background: "rgba(255,255,255,0.1)",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.background = "rgba(255,255,255,0.25)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.background = "rgba(255,255,255,0.1)")
                }
              >
                Astrologer Registration
              </Link>
            </Col>

            {/* Social Media */}
            <Col
              xs={12}
              md={3}
              className="d-flex align-items-center justify-content-center justify-content-md-end gap-2"
            >
              {[FaFacebook, FaTwitter, FaInstagram].map((Icon, idx) => (
                <a
                  key={idx}
                  href="#"
                  className="text-white d-flex align-items-center justify-content-center rounded-circle"
                  style={{
                    width: "32px",
                    height: "32px",
                    background: "rgba(255,255,255,0.2)",
                    transition: "0.3s",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.background = "rgba(255,255,255,0.4)")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.background = "rgba(255,255,255,0.2)")
                  }
                >
                  <Icon size={16} />
                </a>
              ))}

              <Link to="/cart" className="position-relative ms-3">
                <FaCartArrowDown className="text-white fs-4" />

                {cartCount > 0 && (
                  <span
                    className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                    style={{ fontSize: "0.65rem" }}
                  >
                    {cartCount}
                  </span>
                )}
              </Link>
            </Col>
          </Row>
        </Container>
      </div>
      <Navbar
        expand="lg"
        variant="light"
        bg="light"
        sticky="top"
        className="py-3 box-shadow shadow-sm navbar-scroll"
      >
        <Container>
          <Navbar.Toggle aria-controls="main-navbar" />
          <Navbar.Collapse id="main-navbar">
            <Nav className="d-flex justify-content-between w-100">
              {/* Reports */}
              <NavDropdown
                title="Reports"
                id="reports-dropdown"
                className="custom-dropdown"
                show={showDropdown["reports"]}
                onMouseEnter={() => handleMouseEnter("reports")}
                onMouseLeave={() => handleMouseLeave("reports")}
              >
                <NavDropdown.Item
                  as={Link}
                  to="/career-report"
                  className="dropdown-li"
                >
                  Career Report
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/yearly-horoscope-report"
                  className="dropdown-li"
                >
                  2026 Yearly Horoscope Report
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/saturn-in-your-birth-chart"
                  className="dropdown-li"
                >
                  Saturn (In Your Birth Chart)
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/cosmic-code-lp"
                  className="dropdown-li"
                >
                  Advanced Personalised Kundali(Cosmic Code)
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/rahu-ketu-report"
                  className="dropdown-li"
                >
                  Rahu Ketu Report Transit
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/jupiter-lp"
                  className="dropdown-li"
                >
                  Jupiter Transit
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/lal-kitab"
                  className="dropdown-li"
                >
                  Lal Kitab Report
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/fortune-report"
                  className="dropdown-li"
                >
                  Fortune Report
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/baby-report"
                  className="dropdown-li"
                >
                  Baby Name Report
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/kundli-matching"
                  className="dropdown-li"
                >
                  Personalised Couple Kundali Matching
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/the-premium-personalized-kundli"
                  className="dropdown-li"
                >
                  Premmium Personalised Kundali
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/kaal-sarp-and-manglik-dosh-og"
                  className="dropdown-li"
                >
                  Kaal Sarp & Manglik Dosh Report
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/love-report-og"
                  className="dropdown-li"
                >
                  Love Report
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/sadesati-report-og"
                  className="dropdown-li"
                >
                  Sade Sati Report
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/fortune-report-plus"
                  className="dropdown-li"
                >
                  Fortune Report Plus
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to="/yearly-report"
                  className="dropdown-li"
                >
                  When will I get Rich?(Finance Report)
                </NavDropdown.Item>
              </NavDropdown>
              <Nav.Link as={Link} to="/products" className="fw-bold mt-2">
                Products
              </Nav.Link>
              {/* Consultation */}
              {/* <NavDropdown
                title="Call Consultation"
                id="call-consultation-dropdown"
                className="custom-dropdown"
                show={showDropdown["call-consultation"]}
                onMouseEnter={() => handleMouseEnter("call-consultation")}
                onMouseLeave={() => handleMouseLeave("call-consultation")}
              >
                <NavDropdown.Item href="#the-call-consultation">
                  Call Consultation
                </NavDropdown.Item>
                <NavDropdown.Item href="#astroogy-consultation">
                  Astrology Consultation
                </NavDropdown.Item>
              </NavDropdown> */}

              {/* ask our astrologer */}
              <Nav.Link as={Link} to="/astrologers" className="fw-bold mt-2">
                Astrologer
              </Nav.Link>
              {/* courses */}
              <Nav.Link as={Link} to="/courses" className="fw-bold mt-2">
                Courses
              </Nav.Link>
              {/* free calculator */}
              <NavDropdown
                title="Free Calculator"
                id="free-calculator"
                className="custom-dropdown"
                show={showDropdown["free-calculator"]}
                onMouseEnter={() => handleMouseEnter("free-calculator")}
                onMouseLeave={() => handleMouseLeave("free-calculator")}
              >
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#rahu-ketu-calculator"
                >
                  Free Rahu Ketu Calculator
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#lal-kitab-calculator"
                >
                  Free Lal Kitab Calculator
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#sade-sati-calculator"
                >
                  Free Sade Sati Calculator
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#flames-calculator"
                >
                  Free Flame Calculator
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#free-kundli-calculator"
                >
                  Free Kundli Calculator
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#lagna-navamsa-calculator"
                >
                  Free Lagna Navamsa Calculator
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#lucky-rudraksha-calculator"
                >
                  Free Lucky Rudraksha Calculator
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#lucky-dates-calculator"
                >
                  Free Lucky Dates Calculator
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#unlucky-dates-calculator"
                >
                  Free Unlucky Dates Calculator
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#match-making-calculator"
                >
                  Free Match Making Calculator
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#numerology-calculator"
                >
                  Free Numerology Calculator
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#lucky-color-calculator"
                >
                  Free Lucky Color Calculator
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#unlucky-color-calculator"
                >
                  Free Unlucky Color Calculator
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#personal-year-calculator"
                >
                  Free Personal Year Calculator
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#lucky-vehicle-number-calculator"
                >
                  Free Lucky Vehicle Number Calculator
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#favourable-alphabets-and-numbers"
                >
                  Free Favourable alphabet and Numbers Calculator
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#moonsign-calculator"
                >
                  Free MoonSign Calculator
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#nakshatra-calculator"
                >
                  Free Nakshatra Calculator
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#name-number-calculator"
                >
                  Free Name Number Calculator
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#lo-shu-grid-planes-numerology"
                >
                  Free Lo Shu Grid Calculator
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#love-calculator"
                >
                  Free Love Calculator
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#memorable-period-of-life"
                >
                  Free Memorable Period of Life Calculator
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#predictive-personality"
                >
                  Free Predictive personality Calculator
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#baby-name-generator"
                >
                  Free Baby Name Calculator
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#destiny-number"
                >
                  Free Destiny Number Calculator
                </NavDropdown.Item>
              </NavDropdown>
              {/* panchang */}
              <NavDropdown
                title="Panchang"
                id="panchang"
                className="custom-dropdown"
                show={showDropdown["panchang"]}
                onMouseEnter={() => handleMouseEnter("panchang")}
                onMouseLeave={() => handleMouseLeave("panchang")}
              >
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#today-panchang"
                >
                  Today's panchang
                </NavDropdown.Item>
              </NavDropdown>
              {/* horoscope */}
              <NavDropdown
                title="Horoscope"
                id="horoscope"
                className="custom-dropdown"
                show={showDropdown["horoscope"]}
                onMouseEnter={() => handleMouseEnter("horoscope")}
                onMouseLeave={() => handleMouseLeave("horoscope")}
              >
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#daily-horoscope"
                >
                  Daily Horoscope
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#weekly-horoscope"
                >
                  Weekly Horoscope
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#weekly-love-horoscope"
                >
                  Weekly Love Horoscope
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#monthly-horoscope"
                >
                  Monthly Horoscope
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#half-yearly-horoscope-2025"
                >
                  Half Yearly Horoscope 2025
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#horoscope-2025"
                >
                  Yearly Horoscope 2025
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#chinese-horoscope-2025"
                >
                  Chinese Horoscope 2025
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#chinese-horoscope-2026"
                >
                  Chinese Horoscope 2026
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#alphabet-horoscope"
                >
                  Alphabet Horoscope
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#numerology-monthly-horoscope"
                >
                  Numerology Monthly Horoscope
                </NavDropdown.Item>
              </NavDropdown>
              <Nav.Link
                as={Link}
                to="/name-correction-ip"
                className="fw-bold mt-2"
              >
                Name Correction
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/online-puja-services"
                className="fw-bold mt-2"
              >
                Online Puja
              </Nav.Link>
              {/* collaborators */}
              <NavDropdown
                title="Collaborations"
                id="collaborations"
                className="custom-dropdown"
                show={showDropdown["collaborations"]}
                onMouseEnter={() => handleMouseEnter("collaborations")}
                onMouseLeave={() => handleMouseLeave("collaborations")}
              >
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#collaborate-with-us"
                >
                  Collaborate With Us
                </NavDropdown.Item>
              </NavDropdown>
              {/* about */}
              <NavDropdown
                title="About"
                id="about"
                className="custom-dropdown"
                show={showDropdown["about"]}
                onMouseEnter={() => handleMouseEnter("about")}
                onMouseLeave={() => handleMouseLeave("about")}
              >
                <NavDropdown.Item className="dropdown-li" as={Link} to="#about">
                  About
                </NavDropdown.Item>
                <NavDropdown.Item className="dropdown-li" as={Link} to="#blogs">
                  Blogs
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  className="dropdown-li"
                  to="#the-pandit-show"
                >
                  The Pandit Show
                </NavDropdown.Item>
              </NavDropdown>

              {/* profile */}
              {authSession && profileUrl && (
                <NavDropdown
                  title={
                    <span>
                      <FaUser className="me-2" />
                      Hi, {name}
                    </span>
                  }
                  id="profile"
                  className="custom-dropdown"
                  show={showDropdown["profile"]}
                  onMouseEnter={() => handleMouseEnter("profile")}
                  onMouseLeave={() => handleMouseLeave("profile")}
                >
                  {/* My Profile */}
                  <NavDropdown.Item
                    className="dropdown-li"
                    onClick={() => {
                      navigate(profileUrl, {
                        state: { tab: "profile" }, // 👈 FORCE profile tab
                      });
                    }}
                  >
                    My Profile
                  </NavDropdown.Item>

                  {/* Messages (users only) */}
                  <NavDropdown.Item
                    className="dropdown-li"
                    onClick={() =>
                      navigate(profileUrl, { state: { tab: "messages" } })
                    }
                  >
                    📩 Messages
                  </NavDropdown.Item>

                  <NavDropdown.Divider />

                  {/* Logout */}
                  <NavDropdown.Item
                    className="dropdown-li"
                    onClick={handleLogout}
                  >
                    Logout
                  </NavDropdown.Item>
                </NavDropdown>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}
